<template>
  <header class="apple-page-heading apple-ui-page-header">
    <div class="apple-ui-page-header-copy"><h1 ref="title" tabindex="-1">{{ title }}</h1><p v-if="subtitle" class="apple-ui-page-header-subtitle">{{ subtitle }}</p></div>
    <div v-if="$slots.default" class="apple-ui-page-header-actions"><slot /></div>
  </header>
</template>
<script>
export default { name: 'ApplePageHeader', props: { title: { type: String, required: true }, subtitle: { type: String, default: '' } }, methods: { focus(options) { this.$refs.title?.focus(options); } } };
</script>
